class MainProduct extends HTMLElement {
  connectedCallback() {
    this.hasPlansData = this.dataset.hasPlans === 'true';
    this.hasPlansUI = !!this.querySelector('.quantity-selector__frequency');
    this.hasPlans = this.hasPlansData && this.hasPlansUI;

    this.defaultVariantId = Number(this.dataset.defaultVariantId || NaN);

    this.initSlider();
    this.initMoonBundleBridge(); // <-- liaison MoonBundle

    this.cureBtns = this.querySelectorAll('.cure-btn');

    this.freqRadios = this.hasPlans ? this.querySelectorAll('input[name="properties[Fréquence]"]') : [];
    this.subBlock = this.hasPlans ? this.querySelector('.frequency__price-discount') : null;
    this.uniqBlock = this.querySelector('.frequency__uniq-price');

    const form = this.getFormEl();
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCart();
      }, { capture: true });
    }

    this.querySelectorAll('.cure-btn, .plan-btn, .swiper--next, .swiper--prev').forEach(btn => {
      if (btn.tagName === 'BUTTON' && !btn.hasAttribute('type')) btn.setAttribute('type', 'button');
    });

    const infoBtn = this.querySelector('[data-open-modal-ingredients]');
    if (infoBtn) this.bindIngredientsTrigger(infoBtn);

    if (this.cureBtns.length) {
      this.cureBtns.forEach(b => b.classList.remove('is-active'));
      this.cureBtns[0].classList.add('is-active');
    }

    this.switchPlansToActiveCure();
    if (this.hasPlans) this.bindPlanClicks();

    this.cureBtns.forEach(btn =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.cureBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        this.switchPlansToActiveCure();
        this.ensureValidFrequencyForActiveVariant();
        this.syncSellingPlanInput(null);
        this.updatePrices();
        this.updateFreeProductsVisibility();
        this.updateUpsellVisibility();
        this.updateCureQuantities();
        this.refreshSellingPlanHiddenInput();
        this.clearFeedback();
      })
    );

    if (this.hasPlans) {
      this.freqRadios.forEach(r => r.addEventListener('change', () => {
        this.ensureValidFrequencyForActiveVariant();
        this.updatePrices();
        this.refreshSellingPlanHiddenInput();
        this.clearFeedback();
      }));

      if (!this.querySelector('input[name="properties[Fréquence]"]:checked')) {
        const sub = this.querySelector('input[name="properties[Fréquence]"][value="Abonnement"]');
        if (sub) {
          sub.checked = true;
          sub.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    const addBtn = this.querySelector('.js-add-to-cart');
    if (addBtn) addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart();
    });

    this.ensureValidFrequencyForActiveVariant();
    this.updatePrices();
    this.updateFreeProductsVisibility();
    this.updateUpsellVisibility();
    this.updateCureQuantities();
    this.refreshSellingPlanHiddenInput();
  }

  initMoonBundleBridge() {
    const options = document.querySelectorAll('.moonbundle-option');
    if (!options.length) return;

    console.log('[MB] options trouvées :', options.length);

    options.forEach(opt => {
      opt.addEventListener('click', () => {
        setTimeout(() => {
          console.log('[MB] option cliquée → updatePrices()');
          this.updatePrices();
        }, 0);
      });
    });

    setTimeout(() => this.updatePrices(), 0);
  }

  bindIngredientsTrigger(btn) {
    if (!btn.hasAttribute('role')) btn.setAttribute('role', 'button');
    if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
    if (!btn.getAttribute('aria-label')) {
      const txt = (btn.textContent || '').trim();
      if (txt) btn.setAttribute('aria-label', txt);
    }

    const onActivate = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const targetSel = btn.getAttribute('data-target');
      this.openIngredientsModal(targetSel);
    };

    btn.addEventListener('click', onActivate);
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate(e);
      }
    });
  }

  openIngredientsModal(targetSelector = null) {
    let modal = null;
    if (targetSelector) modal = document.querySelector(targetSelector);
    if (!modal) modal = document.querySelector('#modal-ingredients');
    if (!modal) modal = document.querySelector('[data-modal="ingredients"]');

    if (!modal) {
      document.dispatchEvent(new CustomEvent('ingredients:open'));
      return;
    }

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');

    const closeBtns = modal.querySelectorAll('[data-close-modal], .js-close-ingredients');
    const overlay = modal.querySelector('.modal__overlay, [data-modal-overlay]');

    const onEsc = (e) => { if (e.key === 'Escape') this.closeIngredientsModal(modal); };
    const onOverlay = (e) => { if (e.target === overlay) this.closeIngredientsModal(modal); };
    const onCloseBtn = () => this.closeIngredientsModal(modal);

    modal._ingredients_cleanup = () => {
      document.removeEventListener('keydown', onEsc);
      if (overlay) overlay.removeEventListener('click', onOverlay);
      closeBtns.forEach(b => b.removeEventListener('click', onCloseBtn));
      delete modal._ingredients_cleanup;
    };

    document.addEventListener('keydown', onEsc);
    if (overlay) overlay.addEventListener('click', onOverlay);
    closeBtns.forEach(b => b.addEventListener('click', onCloseBtn));

    const focusable = modal.querySelector('[tabindex], a, button, input, select, textarea');
    if (focusable) focusable.focus();
  }

  closeIngredientsModal(modal) {
    if (!modal) modal = document.querySelector('#modal-ingredients, [data-modal="ingredients"]');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    if (typeof modal._ingredients_cleanup === 'function') {
      modal._ingredients_cleanup();
    }
  }

  getFeedbackEl() { return this.querySelector('.product__actions-feedback'); }
  clearFeedback() {
    const el = this.getFeedbackEl();
    if (!el) return;
    el.textContent = '';
    el.classList.add('sr-only');
    el.classList.remove('is-error', 'is-success');
    if (this._hideTimer) { clearTimeout(this._hideTimer); this._hideTimer = null; }
  }
  showFeedback(message, type = 'error') {
    const el = this.getFeedbackEl();
    if (!el) return;
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.textContent = message;
    el.classList.remove('sr-only');
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
    if (this._hideTimer) clearTimeout(this._hideTimer);
    this._hideTimer = setTimeout(() => this.clearFeedback(), 6000);
  }

  bindPlanClicks() {
    if (!this.hasPlans) return;
    const all = this.querySelectorAll('.frequency__buttons .plan-btn');
    all.forEach(btn =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const cont = e.currentTarget.closest('.frequency__buttons');
        cont.querySelectorAll('.plan-btn').forEach(b => b.classList.remove('active'));
        e.currentTarget.classList.add('active');
        this.updatePrices();
        this.refreshSellingPlanHiddenInput();
        this.clearFeedback();
      })
    );
  }

  getActiveCureBtn() {
    return this.querySelector('.cure-btn.is-active') || this.querySelector('.cure-btn') || null;
  }
  getActiveCureIndex() {
    const btns = Array.from(this.cureBtns || []);
    const active = this.getActiveCureBtn();
    const idx0 = btns.indexOf(active);
    return idx0 >= 0 ? idx0 + 1 : 1;
  }
  updateCureQuantities() {
    const qtyEls = this.querySelectorAll('.product-cure__quantity');
    if (!qtyEls.length) return;
    const idx = this.getActiveCureIndex();
    qtyEls.forEach(el => el.textContent = `x${idx}`);
  }

  getVisiblePlansContainer() {
    if (!this.hasPlans) return null;
    const groups = Array.from(this.querySelectorAll('.frequency__buttons'));
    return groups.find(g => g.style.display !== 'none') || groups[0] || null;
  }

  getActiveVariantId() {
    const v = this.getActiveCureBtn();
    return v ? String(v.dataset.variantId || '') : '';
  }

  switchPlansToActiveCure() {
    if (!this.hasPlans) return;
    const vId = this.getActiveVariantId();
    const groups = this.querySelectorAll('.frequency__buttons');
    groups.forEach(g => {
      const show = String(g.dataset.variantId || '') === vId;
      g.style.display = show ? '' : 'none';
      if (show) {
        const btns = g.querySelectorAll('.plan-btn');
        btns.forEach(b => b.classList.remove('active'));
        if (btns[0]) btns[0].classList.add('active');
      }
    });
  }

  ensureValidFrequencyForActiveVariant() {
    if (!this.hasPlans) return;

    const vId = this.getActiveVariantId();
    const group = Array.from(this.querySelectorAll('.frequency__buttons'))
      .find(g => String(g.dataset.variantId || '') === vId);

    const hasPlansForVariant = group ? String(group.dataset.hasPlans) === 'true' : false;

    const rSub  = this.querySelector('input[name="properties[Fréquence]"][value="Abonnement"]');
    const rOnce = this.querySelector('input[name="properties[Fréquence]"][value=""]');

    if (!rSub || !rOnce) return;

    if (!hasPlansForVariant) {
      if (rSub.checked) {
        rOnce.checked = true;
        rOnce.dispatchEvent(new Event('change', { bubbles: true }));
      }
      rSub.disabled = true;
      rSub.setAttribute('aria-disabled', 'true');
      this.syncSellingPlanInput(null);
    } else {
      rSub.disabled = false;
      rSub.removeAttribute('aria-disabled');
    }
  }

  updateFreeProductsVisibility() {
    const containers = Array.from(this.querySelectorAll('.free-product__container'));
    if (!containers.length) return;

    const activeCure = this.getActiveCureBtn();
    const rawList = (activeCure?.dataset?.freeVariantId ? String(activeCure.dataset.freeVariantId) : '').trim();
    const activeVariantId = this.getActiveVariantId();

    const allowedIds = new Set(
      rawList.split(/[\s,;]+/).map(s => s.trim()).filter(Boolean)
    );

    containers.forEach(el => {
      const belongsToActiveVariant = String(el.dataset.currentVariant || '') === activeVariantId;
      const giftId = (el.dataset.freeVariantId || '').trim();
      const show = belongsToActiveVariant && allowedIds.size > 0 && allowedIds.has(giftId);

      el.classList.toggle('is-visible', show);
      el.classList.toggle('is-hidden', !show);
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  updateUpsellVisibility() {
    const upsellCards = Array.from(this.querySelectorAll('.upsell-card'));
    if (!upsellCards.length) return;

    const activeVariantId = this.getActiveVariantId();

    upsellCards.forEach(el => {
      const belongsToActiveVariant = String(el.dataset.currentVariant || '') === activeVariantId;

      el.classList.toggle('is-visible', belongsToActiveVariant);
      el.classList.toggle('is-hidden', !belongsToActiveVariant);
      el.setAttribute('aria-hidden', belongsToActiveVariant ? 'false' : 'true');

      if (!belongsToActiveVariant) {
        const checkbox = el.querySelector('.upsell-checkbox');
        if (checkbox) checkbox.checked = false;
      }
    });
  }

  getFormEl() {
    return this.querySelector('form[action*="/cart/add"]') ||
           this.closest('section')?.querySelector('form[action*="/cart/add"]') ||
           this.querySelector('form');
  }

  syncSellingPlanInput(planId) {
    const form = this.getFormEl();
    if (!form) return;

    if (!this.hasPlans) {
      const existing = form.querySelector('input[name="selling_plan"]');
      if (existing) existing.remove();
      return;
    }

    let input = form.querySelector('input[name="selling_plan"]');
    const shouldHaveInput = !!planId && this.isSubscription();

    if (shouldHaveInput) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      input.value = String(planId);
    } else if (input) {
      input.remove();
    }
  }

  refreshSellingPlanHiddenInput() {
    if (!this.hasPlans || !this.isSubscription()) {
      this.syncSellingPlanInput(null);
      return;
    }
    const cont = this.getVisiblePlansContainer();
    const btn = cont ? (cont.querySelector('.plan-btn.active') || cont.querySelector('.plan-btn')) : null;
    const planId = btn ? String(btn.dataset.sellingPlanId || '') : '';
    this.syncSellingPlanInput(planId || null);
  }

  initSlider() {
    const mainEl = this.querySelector('.swiper-product');
    const thumbsEl = this.querySelector('.swiper-thumbs');
    const nextEl = this.querySelector('.swiper--next');
    const prevEl = this.querySelector('.swiper--prev');

    const thumbsSwiper = new Swiper(thumbsEl, {
      spaceBetween: 6,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slidesPerView: 'auto',
      slideToClickedSlide: true
    });

    const mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 6,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      roundLengths: true,
      navigation: { nextEl, prevEl },
      thumbs: { swiper: thumbsSwiper },
      breakpoints: { 768: { centeredSlides: false, centeredSlidesBounds: false, spaceBetween: 10 } }
    });

    this._mainSwiper = mainSwiper;
    this._thumbsSwiper = thumbsSwiper;
  }

  fmt(n) {
    const s = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n);
    return s.replace(/[\u00A0\u202F](€)/, '$1');
  }

  parsePriceFromEl(el) {
    if (!el) return 0;
    const t = (el.textContent || '')
      .trim()
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\.(?=\d{3}\b)/g, '')
      .replace(',', '.');
    const v = parseFloat(t);
    return Number.isFinite(v) ? v : 0;
  }

  getDiscountRate() {
    if (!this.hasPlans) {
      console.log('[DISCOUNT DEBUG] No plans, rate = 1');
      return 1;
    }
    const el = this.querySelector('.frequency__input .cure__discount');
    if (!el) {
      console.log('[DISCOUNT DEBUG] Badge not found, rate = 1');
      return 1;
    }
    const text = el.textContent;
    console.log('[DISCOUNT DEBUG] Badge found, text:', text);
    const m = text.match(/(\d+)\s*%/);
    if (!m) {
      console.log('[DISCOUNT DEBUG] No match for percentage, rate = 1');
      return 1;
    }
    const pct = parseInt(m[1], 10);
    if (!Number.isFinite(pct)) {
      console.log('[DISCOUNT DEBUG] Invalid percentage, rate = 1');
      return 1;
    }
    const rate = 1 - pct / 100;
    console.log('[DISCOUNT DEBUG] Calculated rate:', rate, 'from', pct, '%');
    return Math.min(1, Math.max(0, rate));
  }

  isSubscription() {
    if (!this.hasPlans) return false;
    const r = this.querySelector('input[name="properties[Fréquence]"]:checked');
    if (!(r && r.value === 'Abonnement')) return false;
    const group = this.getVisiblePlansContainer();
    const hasPlansForVariant = group ? String(group.dataset.hasPlans) === 'true' : false;
    return hasPlansForVariant;
  }

  getCtaPriceEl() {
    const btn = this.querySelector('.js-add-to-cart');
    if (!btn) return null;
    return btn.querySelector('.js-cta-price') || btn.querySelector('span:last-child');
  }

  updateCTA(base, compare) {
    const el = this.getCtaPriceEl();
    if (!el) return;

    if (Number.isFinite(compare) && compare > base) {
      el.innerHTML = `
        <span class="old-price">${this.fmt(compare)}</span>
        <span class="new-price">${this.fmt(base)}</span>
      `;
    } else {
      el.textContent = this.fmt(base);
    }
  }

  updatePrices() {
    console.log('--- UPDATE PRICES ---');

    const activeMoon = document.querySelector('.moonbundle-option.moonbundle-option-active');
    if (activeMoon) {
      const priceEl = activeMoon.querySelector('.moonbundle-option-single-price');
      const oldEl   = activeMoon.querySelector('.moonbundle-option-old-price');

      let base    = this.parsePriceFromEl(priceEl);
      let compare = oldEl ? this.parsePriceFromEl(oldEl) || base : base;

      console.log('[MB] prix bundle actif → base:', base, 'compare:', compare);

      if (this.uniqBlock) {
        const s = this.uniqBlock.querySelector('.s-price');
        const o = this.uniqBlock.querySelector('.old-price');
        if (s) s.textContent = this.fmt(base);
        if (o) {
          if (Number.isFinite(compare) && compare > base) {
            o.textContent = this.fmt(compare);
            o.style.display = '';
          } else {
            o.textContent = '';
            o.style.display = 'none';
          }
        }
      }

      if (this.subBlock) {
        const s = this.subBlock.querySelector('.s-price');
        const o = this.subBlock.querySelector('.old-price');
        if (s) s.textContent = this.fmt(base);
        if (o) {
          if (Number.isFinite(compare) && compare > base) {
            o.textContent = this.fmt(compare);
          } else {
            o.textContent = '';
          }
        }
      }

      this.updateCTA(base, compare);
      console.log('[MB] CTA mis à jour avec prix bundle');
      return;
    }

    let base;
    let compare;

    const btn = this.getActiveCureBtn();

    if (btn) {
      base = this.parsePriceFromEl(btn.querySelector('.new-price'));
      compare = this.parsePriceFromEl(btn.querySelector('.old-price')) || base;
      console.log('[PRICE] fallback cure-btn → base:', base, 'compare:', compare);
    } else {
      base = Number(this.dataset.defaultPrice || 0);
      compare = Number(this.dataset.defaultCompare || base);
      console.log('[PRICE] fallback defaults → base:', base, 'compare:', compare);
    }

    const rate = this.getDiscountRate();
    const sub = base * rate;
    console.log('[PRICE] discount rate:', rate, 'sub price:', sub);

    if (this.uniqBlock) {
      const s = this.uniqBlock.querySelector('.s-price');
      const o = this.uniqBlock.querySelector('.old-price');
      if (s) s.textContent = this.fmt(base);
      if (o) {
        if (Number.isFinite(compare) && compare > base) {
          o.textContent = this.fmt(compare);
          o.style.display = '';
        } else {
          o.textContent = '';
          o.style.display = 'none';
        }
      }
    }

    if (this.subBlock) {
      const s = this.subBlock.querySelector('.s-price');
      const o = this.subBlock.querySelector('.old-price');
      if (s) s.textContent = this.fmt(sub);
      if (o) o.textContent = this.fmt(compare);
    }

    const priceForCTA = this.isSubscription() ? sub : base;
    console.log('Prix CTA → base:', base, 'compare:', compare, 'priceForCTA:', priceForCTA);
    this.updateCTA(priceForCTA, compare);
  }

  addToCart() {
    let variantId = NaN;
    let planId = null;
    let freq = '';
    const quantity = 1;
    const items = [];

    const activeCure = this.getActiveCureBtn();

    if (activeCure) {
      variantId = Number(activeCure?.dataset?.variantId || NaN);
    } else {
      variantId = this.defaultVariantId;
    }

    if (!Number.isFinite(variantId)) {
      this.showFeedback('Variante indisponible.', 'error');
      return;
    }

    if (this.hasPlans) {
      const checked = this.querySelector('input[name="properties[Fréquence]"]:checked');
      freq = checked ? checked.value || '' : '';

      const visibleGroup = this.getVisiblePlansContainer();
      const hasPlansForVariant = visibleGroup ? String(visibleGroup.dataset.hasPlans) === 'true' : false;

      if (freq === 'Abonnement' && hasPlansForVariant) {
        const btn = visibleGroup.querySelector('.plan-btn.active') || visibleGroup.querySelector('.plan-btn');
        planId = btn ? String(btn.dataset.sellingPlanId || '') : null;
        if (!planId) {
          this.showFeedback("Choisissez une durée d'abonnement.", 'error');
          return;
        }
      } else if (freq === 'Abonnement' && !hasPlansForVariant) {
        const rOnce = this.querySelector('input[name="properties[Fréquence]"][value=""]');
        if (rOnce) {
          rOnce.checked = true;
          rOnce.dispatchEvent(new Event('change', { bubbles: true }));
        }
        freq = '';
        planId = null;
      }

      this.syncSellingPlanInput(planId);
    } else {
      this.syncSellingPlanInput(null);
      freq = '';
    }

    items.push({ id: variantId, quantity, properties: { 'Fréquence': freq } });

    const rawList = String(this.getActiveCureBtn()?.dataset?.freeVariantId || '');
    const freeIds = rawList.split(/[\s,;]+/).map(s => s.trim()).filter(Boolean);
    freeIds.forEach(fid => {
      const num = Number(fid);
      if (Number.isFinite(num)) {
        const freeEl = this.querySelector(`.free-product__container[data-free-variant-id="${fid}"]`);
        const freePlanIds = freeEl?.dataset?.sellingPlanIds;
        let freePlanId = null;

        if (freq === 'Abonnement' && planId && freePlanIds) {
          const activePlanBtn = this.querySelector('.plan-btn.active');
          if (activePlanBtn) {
            const allPlanBtns = this.querySelectorAll('.plan-btn');
            const planIndex = Array.from(allPlanBtns).indexOf(activePlanBtn);
            const freePlansArray = freePlanIds.split(',');
            if (planIndex >= 0 && planIndex < freePlansArray.length) {
              freePlanId = Number(freePlansArray[planIndex]);
            }
          }
        }

        const item = {
          id: num,
          quantity: 1,
          properties: { 'Free gift': 'true', 'Gift trigger': String(variantId) }
        };

        items.push(item);
        if (freePlanId && items.length > 0) {
          const itemIndex = items.length - 1;
          if (!items[itemIndex]._sellingPlan) items[itemIndex]._sellingPlan = freePlanId;
        }
      }
    });

    const checkedUpsells = Array.from(this.querySelectorAll('.upsell-checkbox:checked'));
    checkedUpsells.forEach(checkbox => {
      const upsellVariantId = Number(checkbox.dataset.upsellVariant);
      if (Number.isFinite(upsellVariantId)) {
        items.push({
          id: upsellVariantId,
          quantity: 1,
          properties: { 'Upsell': 'true' }
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items.map((it, i) => {
          const e = { id: it.id, quantity: it.quantity, properties: it.properties || {} };
          if (i === 0 && planId) e.selling_plan = planId;
          if (i > 0 && it._sellingPlan) e.selling_plan = it._sellingPlan;
          return e;
        })
      })
    })
      .then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)))
      .then(data => {
        console.log('[UPSELL DEBUG] Cart add successful, dispatching cart:updated event', { data, variantId, planId });
        try { sessionStorage.setItem('sidecart:last', JSON.stringify({ cart: data, variantId, planId, sellingPlan: planId })); } catch (e) { }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data, variantId, planId, sellingPlan: planId } }));
        console.log('[UPSELL DEBUG] Event dispatched');
      })
      .catch((e) => {
        const msg = (e && e.description) ? e.description : "Impossible d'ajouter l'article au panier.";
        this.showFeedback(msg, 'error');
      });
  }
}

if (!customElements.get('main-product')) {
  customElements.define('main-product', MainProduct);
}
